import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function post(data) {
  const response = await http.postData("/visum-et-repertum", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function put(id, data) {
  const response = await http.putData(`/visum-et-repertum/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function getByReg(reg) {
  const response = await http.getData(`/register/${reg}/visum-et-repertum`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function getById(id) {
  const response = await http.getData(`/visum-et-repertum/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

async function destroy(id) {
  const response = await http.deleteData(`/visum-et-repertum/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response.data;
}

function print(id) {
  window.open(`${http.getAPI()}/visum-et-repertum/${id}/pdf`, "_blank");
}

async function signDokter(id, data) {
  const response = await http
    .putData(`/visum-et-repertum/${id}/sign-dokter`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function addLuka(id, data) {
  const response = await http.postData(`/visum-et-repertum/${id}/luka`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function updateLuka(id, lukaId, data) {
  const response = await http
    .putData(`/visum-et-repertum/${id}/luka/${lukaId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteLuka(id, lukaId) {
  const response = await http
    .deleteData(`/visum-et-repertum/${id}/luka/${lukaId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function uploadFoto(
  id,
  file: File,
  meta: { kategori?: string; visum_luka_id?: number | null; catatan?: string }
) {
  const form = new FormData();
  form.append("file", file);
  if (meta.kategori) form.append("kategori", meta.kategori);
  if (meta.visum_luka_id) form.append("visum_luka_id", String(meta.visum_luka_id));
  if (meta.catatan) form.append("catatan", meta.catatan);

  const response = await http.postData(`/visum-et-repertum/${id}/foto`, form).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function deleteFoto(id, fotoId) {
  const response = await http
    .deleteData(`/visum-et-repertum/${id}/foto/${fotoId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

export default {
  post,
  put,
  getByReg,
  getById,
  destroy,
  print,
  signDokter,
  addLuka,
  updateLuka,
  deleteLuka,
  uploadFoto,
  deleteFoto,
};
